import instance, { customConfigFormData } from "../../../Utils/Interceptors/Interceptor";

const CargarInforme = async (values) => {
    try {
        let formData = new FormData();
            formData.append('idUsuario', values.idUsuario);
            formData.append('archivo', values.archivo);
            formData.append('idPerfil', values.idPerfil);
    
        const resultado = await instance.Backend.post("/InformeConservacion/CargarInforme",formData, customConfigFormData);

        return resultado

    } catch (error) {

        console.log(error);

    }

}
export { CargarInforme };
